import Vue from "vue";

// Use Vuex store
import store from "./store/store";

import vueDebounce from "vue-debounce";
Vue.use(vueDebounce)

// Components
import Form from "./components/Form.vue";
import Results from "./components/Results.vue";


// Plugins
Vue.config.productionTip = true;
Vue.config.devtools = true;



if (document.querySelector("swk-zoeken-form")) {
  new Vue({
    el: "swk-zoeken-form",
    store,
    components: {
      "swk-zoeken-form": Form
    }
  });
}

if (document.querySelector("swk-zoeken-results")) {
  new Vue({
    el: "swk-zoeken-results",
    store,
    components: {
      "swk-zoeken-results": Results
    }
  });
}

